import { useLanguage } from "@/context/LanguageContext";
import { Sparkles } from "lucide-react";

const BrandsBanner = () => {
  const { language } = useLanguage();
  
  const brands = [
    { name: "Botox", company: "by Allergan" },
    { name: "Nuceiva", company: "by Clarion" },
    { name: "Dysport", company: "by Galderma" },
    { name: "Teoxane", company: "by Teoxal" },
    { name: "Revanesse", company: "" },
    { name: "Sculptra", company: "by Galderma" },
    { name: "Vamp", company: "" },
    { name: "Latisse", company: "" },
    { name: "Biostimulators", company: "" },
  ];

  // Double the brands array for seamless infinite scroll
  const scrollBrands = [...brands, ...brands];

  return (
    <section className="py-8 bg-gradient-to-r from-stone-100 via-amber-50 to-stone-100 overflow-hidden border-y border-amber-200/50">
      <div className="max-w-7xl mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-6">
          <p className="text-xs uppercase tracking-[0.25em] text-amber-700 font-medium mb-1">
            {language === "fr" ? "Marques de Confiance" : "Trusted Brands"}
          </p>
          <h3 
            className="text-lg md:text-xl text-gray-800"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            {language === "fr" 
              ? "Nous utilisons uniquement des produits de qualité médicale" 
              : "We Use Only Medical-Grade Products"}
          </h3>
        </div>

        {/* Scrolling Banner */}
        <div className="relative">
          {/* Gradient fade edges */}
          <div className="absolute left-0 top-0 bottom-0 w-20 bg-gradient-to-r from-stone-100 via-stone-100/80 to-transparent z-10 pointer-events-none"></div>
          <div className="absolute right-0 top-0 bottom-0 w-20 bg-gradient-to-l from-stone-100 via-stone-100/80 to-transparent z-10 pointer-events-none"></div>
          
          {/* Scrolling container */}
          <div className="flex animate-scroll">
            {scrollBrands.map((brand, index) => (
              <div 
                key={`${brand.name}-${index}`}
                className="flex-shrink-0 mx-4 md:mx-8 flex items-center gap-3 group"
              >
                {/* Brand Card */}
                <div className="flex items-center gap-3 px-5 py-3 bg-white/80 backdrop-blur-sm rounded-full border border-amber-200/60 shadow-sm hover:shadow-md hover:border-amber-400 transition-all duration-300 cursor-default">
                  <Sparkles className="w-4 h-4 text-amber-500 opacity-70 group-hover:opacity-100 transition-opacity" />
                  <div className="flex flex-col">
                    <span 
                      className="text-gray-800 font-semibold text-sm md:text-base whitespace-nowrap"
                      style={{ fontFamily: "'Playfair Display', serif" }}
                    >
                      {brand.name}
                    </span>
                    {brand.company && (
                      <span className="text-[10px] text-amber-700/80 uppercase tracking-wider whitespace-nowrap">
                        {brand.company}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Certification Note */}
        <p className="text-center text-xs text-gray-500 mt-4">
          {language === "fr" 
            ? "Tous les produits sont approuvés par Santé Canada et administrés par des professionnels certifiés"
            : "All products are Health Canada approved and administered by certified professionals"}
        </p>
      </div>

      {/* CSS Animation */}
      <style jsx>{`
        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
        .animate-scroll {
          animation: scroll 35s linear infinite;
        }
        .animate-scroll:hover {
          animation-play-state: paused;
        }
      `}</style>
    </section>
  );
};

export default BrandsBanner;
